/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} News_Meta_Layouttitle1Inputs */

const ja_news_meta_layouttitle1 = /** @type {(inputs: News_Meta_Layouttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN News.`)
};

const en_news_meta_layouttitle1 = /** @type {(inputs: News_Meta_Layouttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN News.`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN News." |
*
* @param {News_Meta_Layouttitle1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const news_meta_layouttitle1 = /** @type {((inputs?: News_Meta_Layouttitle1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<News_Meta_Layouttitle1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_news_meta_layouttitle1(inputs)
	return en_news_meta_layouttitle1(inputs)
});
export { news_meta_layouttitle1 as "news_meta_layoutTitle" }